import { render } from "./repeatAward.vue?vue&type=template&id=18dbe2b1&scoped=true"
import script from "./repeatAward.vue?vue&type=script&lang=js"
export * from "./repeatAward.vue?vue&type=script&lang=js"

import "./repeatAward.vue?vue&type=style&index=0&id=18dbe2b1&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18dbe2b1"]])

export default __exports__